<template>
  <div class="container-fluid pb-4 px-5 intro">
    <!-- <div class="row py-3" v-if="mode == 'p2u'">
      <div class="bold">What is Preeti to Unicode converter?</div>
      <p>
        Preeti to Unicode converter is a platform to convert texts in preeti
        font to unicode. Preeti is widely popular nepali font. This application
        automatically converts preeti to unicode font. Just write the text in
        above box and the result would be displayed on the bottom box.
      </p>
    </div>
    <div class="row py-3" v-else>
      <div class="bold">What is Unicode to Preeti converter?</div>
      <p>
        Unicode to preeti converter is a platform to convert texts in unicode
        font to preeti. Preeti is widely popular nepali font. This application
        automatically converts unicode to preeti font. Just write the text in
        above box and the result would be displayed on the bottom box.
      </p>
    </div> -->
  </div>
</template>

<script>
export default {
  props: ["mode"],
};
</script>

<style>
.intro {
  background-color: #0893c833;
}
</style>
